// extracted by mini-css-extract-plugin
export default {"stickyHeader":"BulkUsersUploadActivity_stickyHeader__zaBwG","header":"BulkUsersUploadActivity_header__4r+ER"};